// extracted by mini-css-extract-plugin
module.exports = {"content":"Error_content__3CBGd","contentButton":"Error_contentButton__3fNfM"};